import clsx from 'clsx';

import { Button, type ButtonProps } from '../../Button';

import { ctaGroupButtonVariants } from './ctaGroupButtonVariants';

export type CTAGroupItemProps = Omit<ButtonProps, 'color' | 'size' | 'variant'> & {
  isHighlighted?: boolean;
};

export const CTAGroupButton = ({
  className,
  isHighlighted,
  size,
  ...props
}: CTAGroupItemProps & { size?: ButtonProps['size'] }) => (
  <Button
    className={clsx(ctaGroupButtonVariants({ useSeparator: !isHighlighted }), className)}
    color={isHighlighted ? 'primary' : 'white'}
    size={size}
    variant={isHighlighted ? 'primary' : 'transparent'}
    {...props}
  />
);
